module.exports = function (d, UTILS) {
  var g = d.ShaderLib.lambert.vertexShader;
  g = (g =
    "\n        attribute vec3 iOffset;\n        attribute vec3 iScale;\n        attribute vec4 iRotation;\n        attribute vec3 iColor;\n        attribute vec3 iEmissive;\n        attribute vec4 iTexOff;\n        attribute float iTex;\n        attribute float iOpacity;\n        attribute float iVisible;\n        attribute float iAlphaTest;\n        varying vec3 vertexColor;\n        varying vec3 vertexEmissive;\n        varying float vertexTex;\n        varying vec2 vertexTexOff;\n        varying float vertexVisible;\n        varying float vertexOpacity;\n        varying float vertexAlphaTest;\n\n        vec3 applyTRS( vec3 position, vec3 translation, vec4 quaternion, vec3 scale ) {\n            position *= scale;\n            position += 2.0 * cross( quaternion.xyz, cross( quaternion.xyz, position ) + quaternion.w * position );\n            return position + translation;\n        }\n    " +
    g).replace(
    "#include <project_vertex>",
    "\n        // COLOR:\n        vertexColor = iColor;\n        vertexEmissive = iEmissive;\n        vertexOpacity = iOpacity;\n        vertexAlphaTest = iAlphaTest;\n\n        // TEXTURE ATLASS OFFSET:\n        vertexTexOff = vec2(uv.x * (iTexOff[1] - iTexOff[0]) + iTexOff[0],\n            uv.y * (iTexOff[2] - iTexOff[3]) + iTexOff[3]);\n\n        // TEXTURE SRC:\n        vertexTex = iTex;\n\n        // VISIBILITY:\n        vertexVisible = iVisible;\n\n        // POSITION:\n        vec3 vPosition = applyTRS( transformed, iOffset, iRotation, iScale );\n        transformed = vPosition;\n        vec4 mvPosition = modelViewMatrix * vec4( vPosition, 1.0 );\n        gl_Position = projectionMatrix * modelViewMatrix * vec4( vPosition, 1.0 );\n    ",
  );
  let h = new d.BoxBufferGeometry(1, 1, 1);
  h.translate(0, 0.5, 0);
  let j = new d.PlaneBufferGeometry(1, 1, 1, 1);
  let k = new d.Mesh(h);
  let m = new d.Mesh(j);
  class q extends d.Mesh {
    constructor(z, A, B) {
      super();
      this.name = "ShaderMesh";
      this.uniforms = d.UniformsUtils.clone(d.ShaderLib.lambert.uniforms);
      if (B) {
        this.uniforms.texture1 = {
          type: "t",
          value: B.mergedTexture,
        };
        var C = B.ranges;
      }
      this.frustumCulled = false;
      this.material = new d.ShaderMaterial({
        fragmentShader:
          "\n        uniform sampler2D texture1;\n        varying vec3 vertexColor;\n        varying vec3 vertexEmissive;\n        varying float vertexOpacity;\n        varying float vertexVisible;\n        varying float vertexTex;\n        varying vec2 vertexTexOff;\n        varying float vertexAlphaTest;\n\n        uniform vec3 diffuse;\n        uniform vec3 emissive;\n        uniform float opacity;\n\n        varying vec3 vLightFront;\n        varying vec3 vIndirectFront;\n        #ifdef DOUBLE_SIDED\n        \tvarying vec3 vLightBack;\n        \tvarying vec3 vIndirectBack;\n        #endif\n        #include <common>\n        #include <packing>\n        #include <dithering_pars_fragment>\n        #include <color_pars_fragment>\n        #include <uv_pars_fragment>\n        #include <uv2_pars_fragment>\n        #include <map_pars_fragment>\n        #include <alphamap_pars_fragment>\n        #include <aomap_pars_fragment>\n        #include <lightmap_pars_fragment>\n        #include <emissivemap_pars_fragment>\n        #include <envmap_common_pars_fragment>\n        #include <envmap_pars_fragment>\n        #include <cube_uv_reflection_fragment>\n        #include <bsdfs>\n        #include <lights_pars_begin>\n        #include <fog_pars_fragment>\n        #include <shadowmap_pars_fragment>\n        #include <shadowmask_pars_fragment>\n        #include <specularmap_pars_fragment>\n        #include <logdepthbuf_pars_fragment>\n        #include <clipping_planes_pars_fragment>\n\n        void main() {\n            if (vertexVisible == 0.0) discard;\n\n            #include <clipping_planes_fragment>\n\n        \tvec4 diffuseColor = vec4( vertexColor, vertexOpacity );\n        \tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n            vec3 totalEmissiveRadiance = vertexEmissive;\n\n        \t#include <logdepthbuf_fragment>\n            if (vertexTex > 0.0) {\n                vec4 texelColor = texture2D( texture1, vertexTexOff );\n            \tdiffuseColor *= texelColor;\n            }\n        \t#include <alphamap_fragment>\n        \tif ( diffuseColor.a < vertexAlphaTest ) discard;\n        \t#include <specularmap_fragment>\n        \t#include <emissivemap_fragment>\n\n            // accumulation\n            //reflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\n            #ifdef DOUBLE_SIDED\n        \t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n        \t#else\n        \t\treflectedLight.indirectDiffuse += vIndirectFront;\n        \t#endif\n        \t#include <lightmap_fragment>\n        \treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n        \t#ifdef DOUBLE_SIDED\n        \t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n        \t#else\n        \t\treflectedLight.directDiffuse = vLightFront;\n        \t#endif\n        \treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n        \t// modulation\n        \t#include <aomap_fragment>\n        \tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n        \t#include <envmap_fragment>\n        \tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n        \t#include <tonemapping_fragment>\n        \t#include <encodings_fragment>\n        \t#include <fog_fragment>\n        \t#include <premultiplied_alpha_fragment>\n        \t#include <dithering_fragment>\n        }\n    ",
        vertexShader: g,
        uniforms: this.uniforms,
        lights: true,
        dithering: true,
        side: d.DoubleSide,
        fog: true,
        shading: d.FlatShading,
        depthPacking: d.RGBADepthPacking,
        vertexColors: d.VertexColors,
        transparent: false,
      });
      this.geometry = new d.InstancedBufferGeometry().copy(A || h);
      this.geometry.instanceCount = z.length;
      const D = z.length;
      const E = new Float32Array(D * 3);
      const F = new Float32Array(D * 3);
      const G = new Float32Array(D * 1);
      const H = new Float32Array(D * 3);
      const I = new Float32Array(D * 3);
      const J = new Float32Array(D * 4);
      const K = new Float32Array(D * 1);
      const L = new Float32Array(D * 1);
      const M = new Float32Array(D * 4);
      const N = new Float32Array(D * 1);
      this.geometry.setAttribute(
        "iColor",
        new d.InstancedBufferAttribute(E, 3, false),
      );
      this.geometry.setAttribute(
        "iEmissive",
        new d.InstancedBufferAttribute(F, 3, false),
      );
      this.geometry.setAttribute(
        "iAlphaTest",
        new d.InstancedBufferAttribute(G, 1, false),
      );
      this.geometry.setAttribute(
        "iOffset",
        new d.InstancedBufferAttribute(H, 3, false),
      );
      this.geometry.setAttribute(
        "iScale",
        new d.InstancedBufferAttribute(I, 3, false),
      );
      this.geometry.setAttribute(
        "iRotation",
        new d.InstancedBufferAttribute(J, 4, false),
      );
      this.geometry.setAttribute(
        "iOpacity",
        new d.InstancedBufferAttribute(K, 1, false),
      );
      this.geometry.setAttribute(
        "iVisible",
        new d.InstancedBufferAttribute(L, 1, false),
      );
      this.geometry.setAttribute(
        "iTexOff",
        new d.InstancedBufferAttribute(M, 4, false),
      );
      this.geometry.setAttribute(
        "iTex",
        new d.InstancedBufferAttribute(N, 1, false),
      );
      this.geometry.attributes.iVisible.setDynamic(true);
      this.objects = [];
      for (let P = 0; P < D; P++) {
        if (B && z[P].src) {
          if (C[z[P].src]) {
            z[P].texOff = [...Object.values(C[z[P].src])];
            var O = 0.5 / z[P].texOff[4];
            z[P].texOff[0] += O;
            z[P].texOff[1] -= O;
            z[P].texOff[2] -= O;
            z[P].texOff[3] += O;
            z[P].texOff.length = 4;
            z[P].tex = 1;
          } else {
            z[P].texOff = [0, 0, 0, 0];
            z[P].tex = 0;
          }
        } else {
          z[P].texOff = [0, 0, 0, 0];
          z[P].tex = 0;
        }
        if (z[P].type == 0) {
          this.objects.push(
            new v(
              P,
              {
                color: E,
                emissive: F,
                alphaTest: G,
                position: H,
                scale: I,
                rotation: J,
                opacity: K,
                visible: L,
                textureOffset: M,
                texture: N,
              },
              z[P],
            ),
          );
        } else if (z[P].type == 1) {
          this.objects.push(
            new w(
              P,
              {
                color: E,
                emissive: F,
                alphaTest: G,
                position: H,
                scale: I,
                rotation: J,
                opacity: K,
                visible: L,
                textureOffset: M,
                texture: N,
              },
              z[P],
            ),
          );
        }
      }
      this.castShadow = true;
      this.receiveShadow = true;
      this.customDepthMaterial = u;
    }
    clean() {
      this.geometry.dispose();
    }
    dispose() {
      this.geometry.dispose();
      this.material.dispose();
    }
  }
  var u = new d.MeshDepthMaterial({
    depthPacking: d.RGBADepthPacking,
    alphaTest: 0.5,
    blending: d.NoBlending,
  });
  u.onBeforeCompile = (x) => {
    x.vertexShader =
      "\n            #define DEPTH_PACKING 3201\n            attribute vec3 iOffset;\n            attribute vec3 iScale;\n            attribute vec4 iRotation;\n\n            vec3 applyTRS( vec3 position, vec3 translation, vec4 quaternion, vec3 scale ) {\n                position *= scale;\n                position += 2.0 * cross( quaternion.xyz, cross( quaternion.xyz, position ) + quaternion.w * position );\n                return position + translation;\n            }\n        " +
      x.vertexShader;
    x.vertexShader = x.vertexShader.replace(
      "#include <project_vertex>",
      "\n            transformed = applyTRS( transformed, iOffset, iRotation, iScale );\n            vec4 mvPosition = vec4( transformed, 1.0 );\n            mvPosition = modelMatrix * mvPosition;\n            mvPosition = modelViewMatrix * mvPosition;\n            gl_Position = projectionMatrix * mvPosition;\n        ",
    );
    x.fragmentShader = "#define DEPTH_PACKING 3201\n" + x.fragmentShader;
  };
  q.enabled = false;
  q.CUBES = {
    instances: [],
    mesh: null,
  };
  q.PLANES = {
    instances: [],
    mesh: null,
  };
  q.addCube = function (x, y, z, A, B, C, D, E) {
    var F = E.src || "";
    if (F.includes("default")) {
      F = null;
    }
    q.CUBES.instances.push({
      type: 0,
      x: x,
      y: y,
      z: z,
      src: F || null,
      color: E.colr,
      emissive: E.emissive,
      w: A,
      h: B,
      l: C,
      opacity: UTILS.limitMM(E.opacity, 0, 1),
      xR: E.xR,
      yR: E.yR,
      zR: E.zR,
    });
    return q.CUBES.instances.length - 1;
  };
  q.addPlane = function (x, y, z, A, B, C, D, E, F) {
    var G = C.src || "";
    if (G.includes("default")) {
      G = null;
    }
    q.PLANES.instances.push({
      type: 1,
      x: x,
      y: y,
      z: z,
      src: G || null,
      color: C.colr,
      emissive: C.emissive,
      w: A,
      l: B,
      h: 1,
      opacity: UTILS.limitMM(C.opacity, 0, 1),
      xR: D,
      yR: E,
      zR: F,
    });
    return q.PLANES.instances.length - 1;
  };
  q.addRamp = function (x, y, z, A, B, C, D, E, F) {
    var G = E.src || "";
    if (G.includes("default")) {
      G = null;
    }
    var H = Math.sqrt(B * B + C * C);
    q.PLANES.instances.push({
      type: 1,
      x: x,
      y: y + B / 2,
      z: z,
      src: G || null,
      color: E.colr,
      emissive: E.emissive,
      w: A,
      l: H,
      h: 2,
      opacity: UTILS.limitMM(E.opacity, 0, 1),
      xR: -Math.PI / 2 - D,
      yR: Math.asin(B / H),
      zR: F || 0,
      ramp: true,
    });
    return q.PLANES.instances.length - 1;
  };
  q.finalize = function (x, y) {
    if (q.CUBES.instances.length) {
      q.CUBES.mesh = new q(q.CUBES.instances, h, x);
      q.CUBES.instances.length = 0;
      y.add(q.CUBES.mesh);
    }
    if (q.PLANES.instances.length) {
      q.PLANES.mesh = new q(q.PLANES.instances, j, x);
      q.PLANES.instances.length = 0;
      y.add(q.PLANES.mesh);
    }
  };
  q.visibility = function (x, y) {
    if (x.type == 0) {
      q.CUBES.mesh.objects[parseInt(x.meshRef)].visibility(y);
      q.CUBES.mesh.geometry.attributes.iVisible.needsUpdate = true;
    } else if (x.type == 1) {
      q.PLANES.mesh.objects[parseInt(x.meshRef)].visibility(y);
      q.PLANES.mesh.geometry.attributes.iVisible.needsUpdate = true;
    }
  };
  class v {
    constructor(x, y, z) {
      this.index = x;
      this.buffers = y;
      this.data = z;
      this.offsets = {
        position: x * 3,
        rotation: x * 4,
        color: x * 3,
        emissive: x * 3,
        alphaTest: x * 1,
        scale: x * 3,
        opacity: x * 1,
        visible: x * 1,
        textureOffset: x * 4,
        texture: x * 1,
      };
      this.rotation = new d.Quaternion();
      this.position = new d.Vector3();
      this.scale = new d.Vector3();
      this.visible = 1;
      this.textureOffset = [0, 0, 0, 0];
      this.texture = 0;
      this.color = new d.Color();
      this.emissive = new d.Color();
      this.alphaTest = 0;
      this.opacity = 1;
      this.init();
    }
    init() {
      this.color.set(this.data.color || "#ffffff");
      this.color.toArray(this.buffers.color, this.offsets.color);
      this.emissive.set(this.data.emissive || "#000000");
      this.emissive.toArray(this.buffers.emissive, this.offsets.emissive);
      this.textureOffset = this.data.texOff;
      this.buffers.textureOffset[this.offsets.textureOffset] =
        this.textureOffset[0];
      this.buffers.textureOffset[this.offsets.textureOffset + 1] =
        this.textureOffset[1];
      this.buffers.textureOffset[this.offsets.textureOffset + 2] =
        this.textureOffset[2];
      this.buffers.textureOffset[this.offsets.textureOffset + 3] =
        this.textureOffset[3];
      this.texture = this.data.tex;
      this.buffers.texture[this.offsets.texture] = this.texture;
      this.alphaTest = this.data.alphaTest ? this.data.alphaTest : 0;
      this.buffers.alphaTest[this.offsets.alphaTest] = this.alphaTest;
      this.opacity = this.data.opacity || 1;
      this.buffers.opacity[this.offsets.opacity] = this.opacity;
      this.visible = ~~(this.data.visible || 1);
      this.buffers.visible[this.offsets.visible] = this.visible;
      k.position.set(this.data.x || 0, this.data.y || 0, this.data.z || 0);
      k.rotation.set(this.data.yR || 0, this.data.xR || 0, this.data.zR || 0);
      k.quaternion.normalize();
      this.rotation.copy(k.quaternion);
      this.position.copy(k.position);
      this.position.toArray(this.buffers.position, this.offsets.position);
      this.rotation.toArray(this.buffers.rotation, this.offsets.rotation);
      this.scale.set(this.data.w || 1, this.data.h || 1, this.data.l || 1);
      this.scale.toArray(this.buffers.scale, this.offsets.scale);
    }
    visibility(x) {
      this.visible = ~~x;
      this.buffers.visible[this.offsets.visible] = this.visible;
    }
  }
  class w {
    constructor(x, y, z) {
      this.index = x;
      this.buffers = y;
      this.data = z;
      this.offsets = {
        position: x * 3,
        rotation: x * 4,
        color: x * 3,
        emissive: x * 3,
        alphaTest: x * 1,
        scale: x * 3,
        opacity: x * 1,
        visible: x * 1,
        textureOffset: x * 4,
        texture: x * 1,
      };
      this.rotation = new d.Quaternion();
      this.position = new d.Vector3();
      this.scale = new d.Vector3();
      this.visible = 1;
      this.textureOffset = [0, 0, 0, 0];
      this.texture = 0;
      this.color = new d.Color();
      this.emissive = new d.Color();
      this.alphaTest = 0;
      this.opacity = 1;
      this.init();
    }
    init() {
      this.color.set(this.data.color || "#ffffff");
      this.color.toArray(this.buffers.color, this.offsets.color);
      this.emissive.set(this.data.emissive || "#000000");
      this.emissive.toArray(this.buffers.emissive, this.offsets.emissive);
      this.textureOffset = this.data.texOff;
      this.buffers.textureOffset[this.offsets.textureOffset] =
        this.textureOffset[0];
      this.buffers.textureOffset[this.offsets.textureOffset + 1] =
        this.textureOffset[1];
      this.buffers.textureOffset[this.offsets.textureOffset + 2] =
        this.textureOffset[2];
      this.buffers.textureOffset[this.offsets.textureOffset + 3] =
        this.textureOffset[3];
      this.texture = this.data.tex;
      this.buffers.texture[this.offsets.texture] = this.texture;
      this.alphaTest = this.data.alphaTest ? this.data.alphaTest : 0;
      this.buffers.alphaTest[this.offsets.alphaTest] = this.alphaTest;
      this.opacity = this.data.opacity || 1;
      this.buffers.opacity[this.offsets.opacity] = this.opacity;
      this.visible = ~~(this.data.visible || 1);
      this.buffers.visible[this.offsets.visible] = this.visible;
      m.position.set(this.data.x || 0, this.data.y || 0, this.data.z || 0);
      m.rotation.set(
        (this.data.yR || 0) - Math.PI / 2,
        this.data.xR || 0,
        this.data.zR || 0,
      );
      m.quaternion.normalize();
      this.rotation.copy(m.quaternion);
      this.position.copy(m.position);
      this.position.toArray(this.buffers.position, this.offsets.position);
      this.rotation.toArray(this.buffers.rotation, this.offsets.rotation);
      this.scale.set(
        (this.data.w || 1) * 2,
        (this.data.l || 1) * 2,
        this.data.h || 1,
      );
      this.scale.toArray(this.buffers.scale, this.offsets.scale);
    }
    visibility(x) {
      this.visible = ~~x;
      this.buffers.visible[this.offsets.visible] = this.visible;
    }
  }
  return q;
};
